import type { FC } from 'react';

import { useFormStateSafe } from '../../../context';

import type { IProps } from './models';

/**
 * Компонент, для получения и вывода введенных данных из Контекста формы.
 */
export const DisplayField: FC<IProps> = ({ name }) => {
    const finalFormValues = useFormStateSafe({ subscription: { values: true } });

    return finalFormValues?.values[name] || null;
};
